import React from "react";
import PageLayout from "../../../PageLayout";
import { EButton, EModal, EPageTitle, ETable } from "../../../libs/ui";
import { ECard } from "../../../libs/ui/src/Card/ECard";
import { MdDelete, MdEdit } from "react-icons/md";
import {
  Select,
  Skeleton,
  Switch,
  Text,
  Textarea,
  TextInput,
} from "@mantine/core";
import useContentCategory from "./hook/useContentCategory";
import { BsUpload } from "react-icons/bs";
import moment from "moment";

const ContentCategory = () => {
  const {
    loading,
    contentCategoryData,
    contentCategoryDetails,
    open,
    setOpen,
    handleChangeCategory,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    totalRecords,
    prevPage,
    nextPage,
    saveContentCategory,
    onchangeSingalContent,
    onCloseModal,
    confirmOpen,
    setConfirmOpen,
    confirmPayload,
    setConfirmPayload,
    handleConfirmToggle,
    handleToggleRequest,
    handleCancelToggle,
    search,
    setSearch,
    contentCategoryAllData,
  } = useContentCategory();

  const totalPages = Math.ceil(totalRecords / itemsPerPage);

  let startPage = Math.max(1, currentPage - Math.floor(itemsPerPage / 2 / 2));
  let endPage = Math.min(totalPages, startPage + itemsPerPage / 2 - 1);

  if (endPage - startPage + 1 < itemsPerPage / 2) {
    if (currentPage <= Math.ceil(itemsPerPage / 2 / 2)) {
      endPage = Math.min(itemsPerPage / 2, totalPages);
    } else if (currentPage > totalPages - Math.floor(itemsPerPage / 2 / 2)) {
      startPage = Math.max(1, totalPages - itemsPerPage / 2 + 1);
    } else {
      startPage = Math.max(1, currentPage - Math.floor(itemsPerPage / 2 / 2));
      endPage = Math.min(
        totalPages,
        currentPage + Math.floor(itemsPerPage / 2 / 2)
      );
    }
  }

  return (
    <PageLayout>
      <EPageTitle title="Content Category" />
      <div className="flex justify-end w-full">
        <EButton
          className="btn-blue"
          rightIcon={<BsUpload />}
          onClick={() => setOpen(true)}
        >
          Add Content Category
        </EButton>
      </div>
      <div className="mt-4">
        <ECard noHeader title="" customClass="overflow-auto">
          {!loading ? (
            <>
              {contentCategoryAllData?.length > 0 ? (
                <div className="flex justify-end mb-4">
                  <TextInput
                    size="md"
                    placeholder="Search Name"
                    value={search}
                    onChange={(e) => setSearch(e?.target?.value)}
                    className="w-1/3"
                  />
                </div>
              ) : null}

              {contentCategoryData?.length > 0 ? (
                <>
                  <ETable>
                    <thead>
                      <tr>
                        <th>S No.</th>
                        <th>Category Name</th>
                        <th>Category Description</th>
                        <th>created on</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contentCategoryData.map((item: any, index) => {
                        return (
                          <tr>
                            <td>
                              {search
                                ? index + 1
                                : currentPage * itemsPerPage + (index + 1)}
                            </td>
                            <td>{item?.category_Name}</td>
                            <td>{item?.category_Description}</td>
                            <td>
                              {moment(item?.created_on).format("DD-MM-YYYY")}
                            </td>
                            <td className="w-32">
                              <div className="flex items-center ">
                                <Switch
                                  checked={item?.is_Active === 1 ? true : false}
                                  size="lg"
                                  onLabel="Active"
                                  offLabel="Inactive"
                                  onChange={() =>
                                    handleToggleRequest(
                                      item?.content_Category_Id,
                                      item?.is_Active === 1
                                    )
                                  }
                                />
                                {item?.is_Active === 0 ? null : (
                                  <MdEdit
                                    onClick={() =>
                                      onchangeSingalContent(
                                        item?.content_Category_Id
                                      )
                                    }
                                    className="inline ml-4 mt-4 text-xl text-blue-600 cursor-pointer"
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </ETable>

                  <div className="text-end mt-2">
                    {/* Pagination controls */}
                    <EButton
                      className="btn-blue"
                      onClick={prevPage}
                      disabled={currentPage === 0}
                    >
                      Previous
                    </EButton>

                    {/* Render first page */}
                    {startPage > 1 && (
                      <>
                        <EButton
                          onClick={() => setCurrentPage(0)}
                          className="btn-light ml-2"
                        >
                          1
                        </EButton>
                        {startPage > 2 && <span className="ml-2">...</span>}
                      </>
                    )}

                    {/* Render page numbers */}
                    {Array.from(
                      { length: endPage - startPage + 1 },
                      (_, index) => startPage + index
                    ).map((page) => (
                      <EButton
                        key={page}
                        onClick={() => setCurrentPage(page - 1)}
                        className={
                          currentPage === page - 1
                            ? "btn-blue ml-2"
                            : "btn-light ml-2"
                        }
                      >
                        {page}
                      </EButton>
                    ))}

                    {/* Render last page */}
                    {endPage < totalPages && (
                      <>
                        {endPage < totalPages - 1 && (
                          <span className="ml-2">...</span>
                        )}
                        <EButton
                          onClick={() => setCurrentPage(totalPages - 1)}
                          className={
                            currentPage === totalPages - 1
                              ? "btn-blue ml-2"
                              : "btn-light ml-2"
                          }
                        >
                          {totalPages}
                        </EButton>
                      </>
                    )}

                    <EButton
                      className="btn-blue ml-2"
                      onClick={nextPage}
                      disabled={
                        contentCategoryData?.length < itemsPerPage ||
                        currentPage === totalPages - 1
                      }
                    >
                      Next
                    </EButton>
                  </div>
                </>
              ) : (
                <div className="text-blue-600 text-sm mt-2 mb-2 text-center">
                  <Text fz="md">No record Found!</Text>
                </div>
              )}
            </>
          ) : (
            <Skeleton height={220} radius="md" />
          )}
        </ECard>
      </div>

      <EModal
        size="lg"
        title={`${
          contentCategoryDetails?.content_Category_Id ? "Update" : "Add"
        } Content Category`}
        isOpen={open}
        onClose={onCloseModal}
        setIsOpen={onCloseModal}
      >
        <div className="w-full flex flex-col gap-4">
          <TextInput
            size="md"
            required
            label="Name"
            value={contentCategoryDetails?.category_Name}
            onChange={(e) =>
              handleChangeCategory({
                name: "category_Name",
                value: e.target.value,
              })
            }
          />
          <Textarea
            size="md"
            required
            label="Description"
            value={contentCategoryDetails?.category_Description}
            onChange={(e) =>
              handleChangeCategory({
                name: "category_Description",
                value: e.target.value,
              })
            }
          />
        </div>
        <div className="flex justify-end w-full mt-6">
          <EButton
            className="btn-blue"
            onClick={() =>
              saveContentCategory({
                type: contentCategoryDetails?.content_Category_Id
                  ? "Update"
                  : "insert",
                status: "active",
              })
            }
          >
            Submit
          </EButton>
        </div>
      </EModal>

      {/* Confirmation modal for toggling active/inactive */}
      <EModal
        size="sm"
        title="Confirm"
        isOpen={confirmOpen}
        onClose={handleCancelToggle}
        setIsOpen={handleCancelToggle}
      >
        <div className="py-4">
          <p>
            Are you sure you want to{" "}
            <strong>
              {confirmPayload?.status === "active" ? "Activate" : "Deactivate"}
            </strong>{" "}
            this category?
          </p>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <EButton className="btn-light" onClick={handleCancelToggle}>
            Cancel
          </EButton>
          <EButton className="btn-blue" onClick={handleConfirmToggle}>
            Confirm
          </EButton>
        </div>
      </EModal>
    </PageLayout>
  );
};

export default ContentCategory;
